import { appConfig } from 'brand-config';

/**
 * Whether the staff endorsement confirm offers "Suppress communications" (#37246): documents
 * regenerate, but the insured and agent aren't emailed and nothing is mailed via Lob. Brand-gated,
 * underwriters only (internal staff with CanApproveUWReview), and endorsements only (no `action`) —
 * cancel/reinstate/rescind notices can be legally required. policy-mod re-checks all of it server-side.
 */
export const canSuppressCommunications = ({ isAgency, canApproveUWReview, action }) =>
  Boolean(appConfig?.featureFlags?.suppressEndorsementCommunications) &&
  !isAgency &&
  Boolean(canApproveUWReview) &&
  !action;

/** The flag to send on confirm: only when the box was checked AND it was offered. */
export const resolveSuppressCommunications = ({ isAgency, canApproveUWReview, action, checked }) =>
  Boolean(checked) && canSuppressCommunications({ isAgency, canApproveUWReview, action });
